import { FREIGHT_MODE } from '@types';
import DirectionsBoatFilledOutlinedIcon from '@mui/icons-material/DirectionsBoatFilledOutlined';
import DirectionsSubwayOutlinedIcon from '@mui/icons-material/DirectionsSubwayOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import BikeScooterIcon from '@mui/icons-material/BikeScooter';

export const getFreightModeIcon = (mode: FREIGHT_MODE | 'OTHER') => {
	switch (mode) {
	case 'OTHER':
		return BikeScooterIcon;
	case FREIGHT_MODE.COASTAL:
		return DirectionsBoatFilledOutlinedIcon;
	case FREIGHT_MODE.RAIL:
		return DirectionsSubwayOutlinedIcon;
	case FREIGHT_MODE.ROAD:
	default:
		return LocalShippingOutlinedIcon;
	}
}